import { gql } from '@apollo/client';
import { FLIGHT_BASIC_FRAGMENT, FLIGHT_DETAIL_FRAGMENT } from '../fragments';

export const LIST_FLIGHTS_MINIMAL = gql`
  query ListFlightsMinimal(
    $sort: FlightSortInput
    $pagination: PaginationInput
  ) {
    flights(sort: $sort, pagination: $pagination) {
      edges {
        node {
          ...FlightBasic
          userFlight {
            id
            seatNumber
            travelClass
            notes
          }
        }
        cursor
      }
      pageInfo {
        currentPage
        totalPages
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
  ${FLIGHT_BASIC_FRAGMENT}
`;

export const GET_FLIGHT_DETAIL = gql`
  query GetFlightDetail($id: ID!) {
    flight(id: $id) {
      ...FlightDetail
    }
  }
  ${FLIGHT_DETAIL_FRAGMENT}
`;

export const DELETE_USER_FLIGHT = gql`
  mutation DeleteUserFlight($id: ID!) {
    deleteUserFlight(id: $id)
  }
`; 